<template>
    <div class="header">
        <div class="info">
            <div class="text">机&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;构：{{orgName}}</div>
            <div>会计期间：{{account}}</div>
        </div>
        <div v-if="isCustom">
            <slot></slot>
        </div>
        <div v-else class="cancle-btn" @click="cancleOrder">取消本次制单</div>
        <tipsDialog :dialogVisible="tipsDialog" tipsMessage="取消制单将退还已扫描的原始凭证，请确认是否继续操作？">
            <div class="btn-group">
                <div class="cancle-btn" @click="closeTipsDialog">不取消</div>
                <div class="confirm-btn" @click="continueCancle">继续取消</div>
            </div>
        </tipsDialog>
        <!-- 退票流程 -->
        <exitTicketProcess ref="exitTicketProcess" exitTitle="取出全部原始凭证后，请收回托盘" @dishHaveNoPaper="dishHaveNoPaper" @dishHandleFinish="dishHaveNoPaper"></exitTicketProcess>

    </div>
</template>
<script>
import { getCookie } from '@/utils/auth'
import { cancleMakeOrder } from '@/api/order'
import tipsDialog from '@/components/tipsDialog'
import exitTicketProcess from '@/components/exitTicketProcess'
import paperDishMixin from '@/mixin/paperDishMixin'
export default {
    mixins: [paperDishMixin],
    props: {
        btnText:{
            type:String,
            default: '取消本次制单'
        },
        isCustom: {
            type:Boolean,
            default: false
        }
    },
    components: { tipsDialog,exitTicketProcess },
    data(){
        return {
            orgName: '',
            account: '',
            tipsDialog: false
        }
    },
     mounted(){
        this.getCookieInfo()
    },
    methods: {
        getCookieInfo(){
            let orgInfo = JSON.parse(getCookie('orgInfo'))
            this.orgName = orgInfo.orgName || ''
            this.account = getCookie('account')
        },
        closeTipsDialog(){
            this.tipsDialog = false
        },
        cancleOrder(){
            this.tipsDialog = true
        },
        continueCancle(){
            cancleMakeOrder().then(res => {
                if(res.code === 200){
                    // 退票流程，弹出托盘
                    this.tipsDialog = false
                    this.$refs.exitTicketProcess.getDishHavePaper()
                }
            })
        },
        dishHaveNoPaper(){
            this.tipsDialog = false
            this.$router.push({name: 'start'})
        }
    }
}
</script>

<style lang="less" scoped>
    .header {
        .info {
            position: absolute;
            top:36px;
            left: 265px;
            font-weight: 500;
            font-size: 32px;
            color: #FFFFFF;
            letter-spacing: 5px;
            .text {
                margin-bottom: 10px;
            }
        }
        .cancle-btn {
            position: absolute;
            padding: 17px 22px;
            top: 42px;
            right: 40px;
            background: rgba(239,239,239,0.5);
            border-radius: 8px;
            font-size: 32px;
            text-align: center;
            color: #FFFFFF;
        }
    }
</style>


